module.exports = "<div class=\"container-fluid search-page hidemeontoggle\">\n     <app-tnsearchpanel></app-tnsearchpanel>\n</div>\n<div class=\"container margin-top-flex\">\n  <h1 class=\"page-title\">Servizi</h1>\n  <!-- {{infoServices.Title}} -->\n  <div [innerHTML]=\"infoServices.Content\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/html/services.component.html
// module id = ../../../../../src/app/themes/default/html/services.component.html
// module chunks = 1